var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vnp-input-box',{attrs:{"value":_vm.val},nativeOn:{"click":function($event){_vm.show = true}}}),_vm._v(" "),_c('vnp-keyboard',{attrs:{"show":_vm.show},on:{"update:show":function($event){_vm.show=$event}},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ebc88aa0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/vant-number-plate/vnp-input.vue
// module id = null
// module chunks = 